import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface EspaceContextValue {
  /** Vrai quand le citoyen navigue dans « Mon espace » (barre latérale affichée). */
  inEspace: boolean;
  enterEspace: () => void;
  exitEspace: () => void;
}
const EspaceContext = createContext<EspaceContextValue>({
  inEspace: false,
  enterEspace: () => {},
  exitEspace: () => {}
});
export function EspaceProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [inEspace, setInEspace] = useState(false);
  const enterEspace = useCallback(() => setInEspace(true), []);
  const exitEspace = useCallback(() => setInEspace(false), []);
  const value = useMemo(() => ({
    inEspace,
    enterEspace,
    exitEspace
  }), [inEspace, enterEspace, exitEspace]);
  return <EspaceContext.Provider value={value} data-id="element-1868" data-mp="9i3v40nxjlwt">{children}</EspaceContext.Provider>;
}
export function useEspace(): EspaceContextValue {
  return useContext(EspaceContext);
}